import { Typography } from '@altibox/lte-salgskanaler-design-system-component-lib';
import { styled } from 'styled-components';

import { breakpointTablet } from 'src/styles/breakpoints';
import { spacing3, spacing4 } from 'src/styles/spacing';

export const StyledContainer = styled.div`
  margin-top: ${spacing4};
  margin-bottom: ${spacing3};

  @media (min-width: ${breakpointTablet}) {
    margin-bottom: 0;
  }
`;

export const StyledTitle = styled(Typography)`
  font-weight: bold;
  margin-bottom: ${spacing3};
`;
